// Scripts for the video promotions component
import Player from '@vimeo/player';

// Dialog management
let vid = document.getElementsByClassName('video-promotion__item');
Array.prototype.forEach.call( vid, function( preview ) {
  preview.onclick = function() {
    document.getElementById('video-promotion-dialog-' + preview.dataset.id).showModal();
  }
});

let vidClose = document.getElementsByClassName('video-promotion__close');
Array.prototype.forEach.call( vidClose, function( close ) {
  close.onclick = function() {
    let id = close.dataset.id;
    document.getElementById('video-promotion-dialog-' + id).close();

    let promoVid = document.getElementById('video-iframe-' + id);
    let player = new Player(promoVid);
    player.pause();
  }
});
